import _locale from "./_locale";

export default {
    _select_container_id: 'filter-marker-form-select-container', //container dos selects do formulário
    _submit_container_id: 'filter-marker-form-submit-container', //container dos botoões do formulário
    _message_container_id: 'filter-marker-message-container', //container da mensagem informativa do formulário
    _title_container_id: 'filter-marker-title-container', //container do titulo do formulário
    _button_submit_id: 'filter-marker-submit-button',
    _button_clear_id: 'filter-marker-clear-button',
    _default_filter_container_id: 'filter-marker-default-filter-container',
    _container_id: undefined, 
    generateSelect(id, options){
        return this.generateSimpleSelect(id, options, true);
    },
    generateSimpleSelect(id, options,label=true){
        return "<div class='form-group'>"+
                ((label) ? "<label>"+(_locale[id] || id + 'Não Definido')+"</label>" : "") +
                "<select class='form-control' data-id='"+id+"_id' multiple='multiple'>" + options.map(x=> "<option value='"+x[0]+"'>"+x[1]+"</option>") + "</select>"+
                "</div>"
    },
    generateBaseStructure(){
        this.setContainerId()
        return "<div id='"+this._container_id+"' class='filter-marker-form'><div class='"+this._title_container_id+"'></div><div class='"+this._select_container_id+"'></div><div class='"+this._default_filter_container_id+"'></div><div class='"+this._submit_container_id+" btn-group d-flex'></div><div class='"+this._message_container_id+"'></div></div>"
    },
    /**
     * Gera os botões do formulário
     * Botões Limpar, Filtrar, etc..
     */
    generateButtons(buttons){
        this.generateButton(buttons.confirm, this._button_submit_id)
        this.generateButton(buttons.clear, this._button_clear_id) 
    },
    generateButton(options, id){
        if(options){
            this.appendSubmitContent("<button class='"+id+" "+options.class+"'>"+options.text+"</button>")  
        }
    },
    generateTitle(title){
        return title
    },
    generateMessage(count){
        return "<span class='count-value'>" + count + "</span> postos filtrados"
    },
    /**
     * Substitui o HTML do espaço reservado ao formulário. Recomenda-se passar todo o formulário no parâmetro HTML
     * @param {String} html conteúdo em HTML
     */
    setSelectContent(html){
        $("#"+this._container_id).find("."+this._select_container_id).html(html)
    },
    /**
     * Adiciona o parâmetro HTML ao HTML do espaço reservado ao formulário.
     * @param {String} html  conteúdo HTML
     */
    appendSelectContent(html){
        $("#"+this._container_id).find("."+this._select_container_id).append(html)
    },
    setSubmitContent(html){
        $("#"+this._container_id).find("."+this._submit_container_id).html(html)
    },
    appendSubmitContent(html){
        $("#"+this._container_id).find("."+this._submit_container_id).append(html)
    },
    setMessageContent(html){
        $("#"+this._container_id).find("."+this._message_container_id).html(html)
    },
    setTitleContent(html){
        $("."+this._title_container_id).html(html)
    },
    setContainerId(){
        this._container_id = "filter_marker_" + (Math.random() + 1).toString(36).substring(7);
    },
    clearSelect(){
        $("#"+this._container_id).find("."+this._select_container_id).html('')
    },
    clearAllSelectedOptions(){
        $("#"+this._container_id).find('.form-control').selectpicker('deselectAll')
    },
    /**
     * Transformando todos os selects do formulário em selectpicker (js library)
     */
     toSelectPicker(){
        $("#"+this._container_id+" .form-control").selectpicker({liveSearch:true, noneSelectedText:"", noneResultsText:"Nada encontrado para {0}",actionsBox:true})
        // removendo o texto em inglês dos botões de ação da library. Não tem nenhuma option para location desses campos. Está sendo alterada para BR via CSS (::after content'Nome')
        $(".actions-btn").html("")
    }
}